import "./LoginBox.css"
import { useContext, useState } from 'react'
import ProfileContext from '../contexts/ProfileContext'
import { useNavigate, Link } from "react-router-dom";
import RegisterContext from "../contexts/RegisterContext";

function LoginBox() {

    const route = useNavigate(); // variable to help route to different page

    // variable to store profile information from profile context
    const {profileData, setProfileData} = useContext(ProfileContext) 

    // const variable to save credential information
    // variable to track user status
    const {credentials, setCredentials, user, setUser} = useContext(RegisterContext)

    // variables to hold info 
    var name = ''
    var bio = ''
    var pic = ''
    var username = ''
    var tags = {}

    // controls routing to main page 
    const route_main = (e) => {
        setProfileData({...profileData, ['name']: name})
        setProfileData({...profileData,['description']: bio})
        setProfileData({...profileData,['username']: username})
        setProfileData({...profileData,['tags']: tags})
        setProfileData({...profileData,['profile_pic_src']: pic})
        
        console.log("login");
        route("/main/profile");
    }

    // saves email to credentials 
    const saveEmail = (e) => {
        const text = e.target.value
        setCredentials({ ...credentials, ['email']: text })
        //console.log(text)
    }
    // saves password to credentials
    const savePassword = (e) => {
        const text = e.target.value
        setCredentials({ ...credentials, ['password']: text })
        //console.log(text)
    }

    // update profileData constants 
    const get_info = (e) => {
        fetch("https://webdev.cse.buffalo.edu/hci/api/api/deekstra" + "/users/" + sessionStorage.getItem("user"),{
            method: "GET",
            headers:{
                'Accept': "*/*",
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            },
            parameters: sessionStorage.getItem("user")
        })
        .then(res => res.json())
        .then(result => {
            if(result){
                console.log("user info retrieved")
                //console.log(result)

                name = result.attributes.name
                bio = result.attributes.description
                pic = result.attributes.profile_pic_src
                username = result.attributes.username
                tags = result.attributes.tags
                

                route_main();  // re-route after retrieving data 
            }else{
                console.log("user info not retrieved")
            }
        },
        error => {
            console.log("error retrieving user")
        });
    }
    

    // controls API call, so makes sure fetch isn't called right away
    const submitHandler = (e) => {
        fetch("https://webdev.cse.buffalo.edu/hci/api/api/deekstra" + "/auth/login", {
            method: "POST",
            headers: {
                'Accept': "*/*",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: credentials.email,
                password: credentials.password
            })
        })
        .then(res => res.json())
        .then(result => {
            if (result.userID){

                console.log("user logged in");

                sessionStorage.setItem("token",result.token);
                sessionStorage.setItem("user",result.userID);
                
                get_info();
            }else{
                setUser(true);

                console.log("failed to login");
            }
        },
        error => {
            //alert("error!");
            setUser(true);
        }
        );
    }

    // function that control submitHandler and routing
    const submission = (e) => {
        submitHandler(e);
    }


    const errorMessages = {
        emailErrors: [],
        passwordErrors: [],
        miscErrors: [],
    }

    function getErrors() {
        if (credentials.email.length < 1)
            errorMessages.emailErrors.push((<div className="form-error">Please enter your email</div>));
        if (credentials.password.length < 1)
            errorMessages.passwordErrors.push(<div className="form-error">Please enter your password</div>);
        if (user)
            errorMessages.miscErrors.push(<div className="input-wrapper"><div className="form-error">Email or password was not recognized</div></div>);
        console.log("ERROR MESSAGES:\n", errorMessages);
    } getErrors();

    const [selectedFields, setSelectedFields] = useState({
        email: "false",
        password: "false",
    });

    return (    
        <div className = "LoginBoxBG">
            <div className = "lg-box-header">
                <h1>Login</h1>
            </div>
            <div className = "lg-InputForm">
                <div className="input-wrapper">
                    <label htmlFor="lg-email" className="form-input-label">Email</label>
                    <input type="text"  name="lg-email" className={(selectedFields.email === "true" && errorMessages.emailErrors.length > 0) ? "rg-input-text-error" : "rg-input-text"} onChange={saveEmail} onBlur={() => setSelectedFields(p => ({...p, email: "true"}))}></input>
                    <div className="form-error">{selectedFields.email === "true" ? errorMessages.emailErrors : null}</div>
                </div>
                <div className="input-wrapper">
                    <label htmlFor="lg-pass" className="form-input-label">Password</label>
                    <input type="password"  name="lg-pass" className={(selectedFields.password === "true" && errorMessages.passwordErrors.length > 0) ? "rg-input-text-error" : "rg-input-text"} onChange={savePassword} onBlur={() => setSelectedFields(p => ({...p, password: "true"}))}></input>
                    <div className="form-error">{selectedFields.password === "true" ? errorMessages.passwordErrors : null}</div>
                </div>
                {errorMessages.miscErrors}
            </div>
            <div className = "lg-box-footer">    
                <button type="submit" className = "lg-button" onClick={submission}>Sign In</button>
                <Link to="/reset" style={{textDecoration: 'none'}}>
                    <div className="forgot-pw">Forgot password?</div>
                </Link>
            </div>
        </div>
    )



   if(user){
        return (    
            <div className = "LoginBoxBG">
                <div className = "lg-box-header">
                    <h1>Login</h1>
                </div>
                <div className = "lg-InputForm">
                    <div className="input-wrapper">
                        <label htmlFor="lg-email" className="form-input-label">Email</label>
                        <input type="text"  name="lg-email" className="lg-input-text" onChange={saveEmail}></input>
                    </div>
                    <div className="input-wrapper">
                        <label htmlFor="lg-pass" className="form-input-label">Password</label>
                        <input type="password"  name="lg-pass" className="lg-input-password" onChange={savePassword}></input>
                    </div>
                   <div className="input-wrapper"> <div className="form-error">Email or password was not recognized</div> </div>
                </div>
                <div className = "lg-box-footer">    
                    <button type="submit" className = "lg-button" onClick={submission}>Sign In</button>
                    <Link to="/reset" style={{textDecoration: 'none'}}>
                        <div className="forgot-pw">Forgot password?</div>
                    </Link>
                </div>
            </div>
        )
    } else {
        return (    
            <div className = "LoginBoxBG">
                <div className = "lg-box-header">
                    <h1>Login</h1>
                </div>
                <div className = "lg-InputForm">
                    <div className="input-wrapper">
                        <label htmlFor="lg-email" className="form-input-label">Email</label>
                        <input type="text"  name="lg-email" className="lg-input-text" onChange={saveEmail}></input>
                    </div>
                    <div className="input-wrapper">
                        <label htmlFor="lg-pass" className="form-input-label">Password</label>
                        <input type="password"  name="lg-pass" className="lg-input-password" onChange={savePassword}></input>
                    </div>
                </div>
                <div className = "lg-box-footer">    
                    <button type="submit" className = "reset-button" onClick={submission}>Sign In</button>
                    {/* <Link to="/reset" style={{textDecoration: 'none'}}>
                    <button type="submit" className = "reset-button">Forgot password?</button>
                    </Link> */}
                    <Link to="/reset" style={{textDecoration: 'none'}}>
                        <div className="forgot-pw">Forgot password?</div>
                    </Link>
                </div>
            </div>
        )
    }
}
export default LoginBox